/* tslint:disable */
/* eslint-disable */
/**
 * Strømbestilling API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SmsKanal = {
    Epost: 'KS_EPOST',
    Chat: 'KS_CHAT',
    Telefon: 'KS_TELEFON'
} as const;
export type SmsKanal = typeof SmsKanal[keyof typeof SmsKanal];


export function instanceOfSmsKanal(value: any): boolean {
    for (const key in SmsKanal) {
        if (Object.prototype.hasOwnProperty.call(SmsKanal, key)) {
            if (SmsKanal[key as keyof typeof SmsKanal] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SmsKanalFromJSON(json: any): SmsKanal {
    return SmsKanalFromJSONTyped(json, false);
}

export function SmsKanalFromJSONTyped(json: any, ignoreDiscriminator: boolean): SmsKanal {
    return json as SmsKanal;
}

export function SmsKanalToJSON(value?: SmsKanal | null): any {
    return value as any;
}

export function SmsKanalToJSONTyped(value: any, ignoreDiscriminator: boolean): SmsKanal {
    return value as SmsKanal;
}

